import { parseDate } from '@global/helpers';

/**
 * Converts a date value to a UTC-midnight ISO 8601 string.
 * Reads local-calendar fields (year/month/day) from the input (e.g. a
 * date-picker value in local tz) and freezes them at UTC midnight, so output
 * is always T00:00:00.000Z — the storage format the API expects.
 * @param {Date|string|number} d - date-picker value (local timezone)
 * @returns {string} ISO 8601 UTC-midnight, e.g. "2026-06-15T00:00:00.000Z"
 */
export const toMidnightUTC = (d) => {
  const dt = new Date(d);
  return new Date(
    Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()),
  ).toISOString();
};

export const formatPeriod = (period, periodType, dates) => {
  if (periodType === 'multiple') {
    if (!dates || !dates.length) {
      return '-';
    }
    return dates.map((d) => parseDate(d, 'dd MMM yyyy')).join(', ');
  }
  if (!period?.start || !period?.end) {
    return '-';
  }
  return `${parseDate(period.start, 'dd MMM yyyy')} - ${parseDate(
    period.end,
    'dd MMM yyyy',
  )}`;
};

export const formatDate = (date) =>
  date ? parseDate(date, 'dd MMM yyyy') : '-';
